import axios from '@/plugins/axios'
import fileDownload from 'js-file-download'

const listShippingServices = async (_, { params } = {}) => {
  return axios.get('shipping-service', { params })
    .then((response) => {
      const data = response.data
      return Array.isArray(data) ? { data } : { data: [] }
    })
    .catch(err => err.response || { data: [] })
}

const fetchShippingServices = async ({ commit }, { includeInactive = true } = {}) => {
  const response = await listShippingServices(undefined, { params: { includeInactive } })
  commit('SET_SHIPPING_SERVICES', response.data || [])
  return response
}

const createShippingService = (_, payload) => {
  return axios.post('shipping-service', payload)
    .then(response => response)
    .catch(err => err.response)
}

const updateShippingService = (_, { id, ...payload }) => {
  return axios.put(`shipping-service/${id}`, payload)
    .then(response => response)
    .catch(err => err.response)
}

const deleteShippingService = (_, id) => {
  return axios.delete(`shipping-service/${id}`)
    .then(response => response)
    .catch(err => err.response)
}

const fetchStoreShippingConfigs = ({ commit }, storeId) => {
  return axios.get(`store-shipping-service/store/${storeId}`)
    .then((response) => {
      commit('SET_STORE_SHIPPING_CONFIGS', response.data)
      return response.data
    })
    .catch(err => err.response)
}

const saveStoreShippingConfigs = (_, { storeId, configs }) => {
  return axios.put(`store-shipping-service/store/${storeId}`, { configs })
    .then(response => response)
    .catch(err => err.response)
}

const upsertStoreShippingConfig = (_, { storeId, config }) => {
  return axios.post(`store-shipping-service/store/${storeId}/config`, config)
    .then(response => response)
    .catch(err => err.response)
}

const deleteStoreShippingConfig = (_, id) => {
  return axios.delete(`store-shipping-service/${id}`)
    .then(response => response)
    .catch(err => err.response)
}

const fetchAvailableShippingServices = ({ commit }, { storeId, regionId }) => {
  return axios.get(`store-shipping-service/available/${storeId}`, {
    params: { regionId }
  })
    .then((response) => {
      commit('SET_AVAILABLE_SHIPPING_SERVICES', response.data)
      return response
    })
    .catch(err => err.response)
}

const downloadMassiveUploadTemplate = (_, { params } = {}) => {
  return axios.get('withdrawal/template/excel', { params, responseType: 'blob' })
    .then((response) => {
      const disposition = response.headers['content-disposition'] || ''
      const match = disposition.match(/filename=([^;]+)/)
      const filename = match ? match[1] : `PlantillaCargaMasiva_${Date.now()}.xlsx`
      fileDownload(response.data, filename)
      return response
    })
    .catch(err => err.response)
}

export {
  listShippingServices,
  fetchShippingServices,
  createShippingService,
  updateShippingService,
  deleteShippingService,
  fetchStoreShippingConfigs,
  saveStoreShippingConfigs,
  upsertStoreShippingConfig,
  deleteStoreShippingConfig,
  fetchAvailableShippingServices,
  downloadMassiveUploadTemplate
}